export const TWITCH_VOD_EXPIRATION_COPY =
  'Twitch VODs may expire depending on broadcaster settings.';

export const TWITCH_VOD_UNAVAILABLE_COPY =
  'This Twitch VOD may have expired or is unavailable. The archive record is still saved in League Stream Center, but Twitch may no longer host the video.';

export const ARCHIVE_PLAYBACK_UNAVAILABLE_TITLE =
  'This Twitch VOD is no longer available on Twitch.';

export const ARCHIVE_PLAYBACK_UNAVAILABLE_BODY =
  'This game remains in the league archive. LSC keeps the record for history, but Twitch no longer hosts the video.';
